import useApiRequest from 'api/useApiRequest';
import {
  uploadFiles,
  addUploadHubItem,
  fetchUploadHubList,
  updateUploadHubItem,
  deleteUploadHubItem,
  logUploadHubEvent,
  type UploadHubListItem,
} from 'api/services/uploadFileService';

export type { UploadHubListItem };

const useUploadFiles = () => {
  const { request } = useApiRequest();

  const uploadFile = async (params: Parameters<typeof uploadFiles>[1]) => {
    const { data } = await uploadFiles(request, params);
    return data;
  };

  const addItemToUploadHub = async (params: Parameters<typeof addUploadHubItem>[1]) => {
    const { data } = await addUploadHubItem(request, params);
    return data;
  };

  const getUploadHubList = async (params: Parameters<typeof fetchUploadHubList>[1]) => {
    const { data } = await fetchUploadHubList(request, params);
    return data;
  };

  const updateItemFromUploadHub = async (params: Parameters<typeof updateUploadHubItem>[1]) => {
    const { data } = await updateUploadHubItem(request, params);
    return data;
  };

  const deleteItemFromUploadHub = async (params: Parameters<typeof deleteUploadHubItem>[1]) => {
    const { data, status } = await deleteUploadHubItem(request, params);
    return { data, status };
  };

  const logEvent = (params: Parameters<typeof logUploadHubEvent>[1]) =>
    logUploadHubEvent(request, params).catch(() => {});

  return {
    uploadFile,
    addItemToUploadHub,
    getUploadHubList,
    updateItemFromUploadHub,
    deleteItemFromUploadHub,
    logEvent,
  };
};

export default useUploadFiles;
